import { CanDeactivateFn } from '@angular/router';

/** Implemented by any routed page component that can hold state which would be silently lost on navigation
 * (an in-progress wizard, dirty inline-edited rows, ...) - see unsavedChangesGuard below. */
export interface CanComponentDeactivate {
  canDeactivate(): boolean;
}

/** Blocks leaving a route - via the toolbar/burger menu, the brand-logo link, browser back/forward, or any
 * other in-app navigation - while the current page's canDeactivate() says there's something to lose. Uses the
 * browser's native confirm(), same as every other "wirklich?" confirmation in this app (see e.g.
 * streets-page.component.ts's delete confirmations), rather than a custom dialog. Does NOT cover closing/
 * reloading the browser tab itself - that's a separate window:beforeunload listener on the component (see
 * CollectorOrderViewPageComponent), since CanDeactivate only runs for Angular-router navigations. */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = component => component.canDeactivate();
